import React, { useEffect, useState } from 'react';

import fetchSimilarItems from '../../app/Search/utils/fetchSimilarItems';
import { ContentClass } from '../../app/Shared/enums';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import ArbitrarySearchResults from './ArbitrarySearchResults';
import SimilarClipsHeader from './SimilarClipsHeader';

interface FullWidthSimilarStockItemsProps {
  detailsUrl: string;
  contentClass: ContentClass;
  contentType?: string;
  headerClassName?: string;
  stockItemCardResponsiveClassNames?: string[];
}

const FullWidthSimilarStockItems: React.FC<FullWidthSimilarStockItemsProps> = ({
  detailsUrl,
  contentClass,
  contentType,
  headerClassName = '',
  stockItemCardResponsiveClassNames,
}) => {
  const [similarStockItems, setSimilarStockItems] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Delays searching for similar stock items until component is rendered
  useEffect(() => {
    const fetchSimilarStockItems = async () => {
      try {
        const searchResult = await fetchSimilarItems(detailsUrl, contentClass);
        setSimilarStockItems(searchResult);
      } catch (error) {
        console.error('Error fetching similar stock items:', error);
      } finally {
        setIsLoading(false);
      }
    };

    void fetchSimilarStockItems();
  }, []);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!similarStockItems || similarStockItems.length < 1) return null;
  else {
    return (
      <SimilarClipsHeader contentType={contentType} className={headerClassName}>
        <ArbitrarySearchResults
          stockItemCardResponsiveClassNames={stockItemCardResponsiveClassNames}
          similarStockItems={similarStockItems}
        />
      </SimilarClipsHeader>
    );
  }
};

export default FullWidthSimilarStockItems;
